// kast-dev family file: legal; master: waypoint_wars/ui/common/utils/legal.ts
// Copied unchanged into every kast-dev app. Change the master, copy it
// everywhere, and run infra/scripts/check-family-files.sh.

/**
 * Legal and account-management URLs.
 *
 * The pages themselves live in the kast-dev-admin repo and are served from
 * kast-dev.net, shared across every Kast Dev app rather than duplicated per
 * app. They are linked from here because both app stores require it: Apple
 * wants the privacy policy reachable from inside the app, and Google wants
 * the account-deletion route discoverable in-app as well as on the listing.
 */

export const PRIVACY_POLICY_URL = "https://kast-dev.net/privacy";
export const TERMS_OF_SERVICE_URL = "https://kast-dev.net/terms";
export const DELETE_ACCOUNT_URL = "https://kast-dev.net/delete-account";

export interface LegalLink {
  label: string;
  url: string;
}

/** Rendered as a list by both clients' settings screens. */
export const LEGAL_LINKS: LegalLink[] = [
  { label: "Privacy Policy", url: PRIVACY_POLICY_URL },
  { label: "Terms of Service", url: TERMS_OF_SERVICE_URL },
  { label: "Delete Account", url: DELETE_ACCOUNT_URL },
];
